module.exports = __webpack_public_path__ + "static/media/knowledge.9b5a6851.yml";